


























































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { IProtocolo, IProtocoloFornecedor, IProtocoloMaterialCodificado } from '@/types/interfaces/protocolo/protocolo.interface'
import { displayColorBySituation } from '@/utils/common'
import { ProtocoloJustificativaOrigemEnum } from '@/types/interfaces/protocolo/protocolo-justificativa-do-medico.interface'

@Component
export default class ComponentProtocoloComparativo extends Vue {
  protocoloJustificativaOrigemEnum = ProtocoloJustificativaOrigemEnum

  @Prop({ required: true, default: 'Solicitado pelo médico' }) medicoTitle: string
  @Prop({ required: true, default: 'Protocolo a ser seguido' }) protocoloTitle: string
  @Prop({ required: true, default: true }) displayAnvisa: boolean
  @Prop({ required: true, default: true }) backoffice: boolean
  @Prop({ required: false, default: false }) readOnly: boolean
  @Prop({ required: true }) surgeryTechniqueId: string = ''
  @Prop({ required: true }) protocolId: string = ''
  @Prop({ required: true }) surgeryMaterialKitId: string = ''
  @Prop({ required: false }) surgeryTechniqueFidelizationBackofficeSuggestion: string = ''
  @Prop({ required: false }) selectedKitFidelizationBackofficeSuggestion: string = ''
  @Prop({ required: false }) protocolFidelizationBackofficeSuggestion: string = ''
  @Prop({ required: false }) availableSurgeryOpmeKitsFidelizationBackofficeSuggestion = []
  @Prop({ required: false }) availableSurgeryTechniquesFidelizationBackofficeSuggestion = []
  @Prop({ required: false }) availableProtocolsFidelizationBackofficeSuggestion = []
  @Prop({ required: false }) protocolDataFidelizationBackofficeSuggestion = []

  selectedKit: string = ''
  protocol: string = ''
  surgeryTechnique: string = ''
  title: string = ''
  allKitsWithSurgeryTechnique = true

  opmeListTableHeaders: any[] = [
    { text: 'Material', class: 'table-headers', sortable: false, align: 'left', value: 'description' },
    { text: 'Quantidade', class: 'table-headers', sortable: false, align: 'center', value: 'quantity' },
    { text: 'Fabricante/marca', class: 'table-headers', sortable: false, align: 'left', value: 'supplier' },
  ]

  materialProtocoloTableHeader: any[] = [
    { text: 'Anvisa', class: 'table-headers', sortable: false, align: 'left', value: 'anvisa' },
    { text: 'Material', class: 'table-headers', sortable: false, align: 'left', value: 'material' },
    { text: 'Quantidade', class: 'table-headers', sortable: false, align: 'center', value: 'quantidade' },
    { text: 'Fabricante/Marca', class: 'table-headers', sortable: false, align: 'left', value: 'fornecedor' },
  ]

  materialProtocoloMedicoTableHeader: any[] = [
    { text: 'Material', class: 'table-headers', sortable: false, align: 'left', value: 'material' },
    { text: 'Quantidade', class: 'table-headers', sortable: false, align: 'center', value: 'quantidade' },
    { text: 'Fabricante/Marca', class: 'table-headers', sortable: false, align: 'left', value: 'fornecedor' },
  ]

  @Emit('materialDataChange')
  changeMaterialData() {}

  @Emit('selectedKitChange')
  changeSelectedKit() {}

  @Emit('surgeryTechniqueChange')
  changeSurgeryTechnique() {}

  @Emit('surgeryProtocolChange')
  changeSurgeryProtocol() {}

  @Emit('selectedProtocolDataChange')
  changeSelectedProtocolData() {}

  @Watch('surgeryTechniqueId')
  onParentSurgeryTechniqueIdChange(value) {
    this.surgeryTechnique = value
  }

  @Watch('protocolId')
  onProtocolIdChange(value) {
    this.protocol = value
  }

  @Watch('surgeryMaterialKitId')
  onSurgeryMaterialKitIdChange(value) {
    this.selectedKit = value
  }

  @Watch('surgeryTechniqueFidelizationBackofficeSuggestion')
  onSurgeryTechniqueFidelizationBackofficeSuggestionChange(value) {
    this.surgeryTechnique = value
  }

  @Watch('protocolFidelizationBackofficeSuggestion')
  onProtocolFidelizationBackofficeSuggestionChange(value) {
    this.protocol = value
  }

  @Watch('protocolDataFidelizationBackofficeSuggestion')
  onProtocolDataFidelizationBackofficeSuggestionChange(value) {
    this.protocolData = value

    if (this.protocolData && (this.protocolData.kitsDeOpme || this.protocolData.kitsDeOpmeV2)) {
      this.updateAvaliableOpmeKits()
    }
  }

  @Watch('selectedKitFidelizationBackofficeSuggestion')
  onSelectedKitFidelizationBackofficeSuggestionChange(value) {
    this.selectedKit = value
  }

  @Watch('availableSurgeryTechniquesFidelizationBackofficeSuggestion')
  onAvailableSurgeryTechniquesFidelizationBackofficeSuggestionChange(value) {
    this.availableSurgeryTechniques = value
  }

  @Watch('availableSurgeryOpmeKitsFidelizationBackofficeSuggestion')
  onAvailableSurgeryOpmeKitsFidelizationBackofficeSuggestionChange(value: any) {
    this.availableSurgeryOpmeKits = value

    const selectedKitInfo = this.availableSurgeryOpmeKits
      && this.availableSurgeryOpmeKits.length > 0 && this.availableSurgeryOpmeKits.find(kit => kit.id === this.selectedKit)

    if (selectedKitInfo) {
      this.$emit('materialDataChange', selectedKitInfo)
    }
  }

  mounted() {
    this.title = `${this.backoffice ? 'Análise de protocolo' : 'Solicitação em análise de fidelização'}`
  }

  onSupplierChange(supplierId, opmeId) {
    const materialData = this.availableSurgeryOpmeKits.find(kit => kit.id === this.selectedKit)
    const kitIndex = this.availableSurgeryOpmeKits.findIndex(kit => kit.id === this.selectedKit)

    if (kitIndex !== -1 && materialData) {
      const opmeIndex = this.availableSurgeryOpmeKits[kitIndex].kitMaterials.findIndex(opme => opme.id === opmeId)
      const opmeData = this.availableSurgeryOpmeKits[kitIndex].kitMaterials.find(opme => opme.id === opmeId)

      opmeData.supplierId = supplierId

      if (opmeIndex !== -1 && opmeData) {
        this.availableSurgeryOpmeKits[kitIndex].kitMaterials[opmeIndex] = opmeData
      }
    }

    this.$emit('materialDataChange', this.availableSurgeryOpmeKits.find(kit => kit.id === this.selectedKit))
  }

  fornecedorV2Change(opme: any, materiais: any) {
    if (!opme || !opme.selectedFornecedor) {
      this.materialV2Change(materiais)
      return
    }

    const selectedFornecedor = opme.selectedFornecedor!

    // Replica o fornecedor selecionado em um material para todo os outros que não tenham fornecedor
    materiais.forEach((kitMaterial) => {
      if (
        !kitMaterial.selectedFornecedor
        && kitMaterial.material.fornecedores.find(elem => elem.fornecedorId === selectedFornecedor.fornecedorId)
      ) {
        kitMaterial.selectedFornecedor = selectedFornecedor
      }
    })

    this.materialV2Change(materiais)
  }

  materialV2Change(materiais: any) {
    const kitMaterials = materiais.map((material) => {
      if (!material.selectedMaterial) {
        return {}
      }

      return {
        id: material.selectedMaterial.id,
        description: material.selectedMaterial.descricao,
        canDoctorUpdateQuantity: material.canDoctorUpdateQuantity,
        quantity: material.quantity,
        supplierId: material.selectedFornecedor && material.selectedFornecedor.fornecedorId,
      }
    })

    const materialData = { kitMaterials }
    this.$emit('materialDataChange', materialData)
  }

  materialCodificadoOptions(opmeInfo: any) {
    return opmeInfo.material.materiaisCodificados
      .filter(elem => opmeInfo.selectedFornecedor && elem.fornecedor.fornecedorId === opmeInfo.selectedFornecedor.fornecedorId)
      .map((material) => {
        let nome = ''
        const nomeDetails = [material.especificidade, material.tamanho, material.modelo]
        nomeDetails.forEach((elem) => {
          if (elem) {
            nome += nome !== '' ? ` - ${elem}` : elem
          }
        })

        return {
          nome: nome || material.descricao,
          material,
        }
      })
  }

  selectedKitChange() {
    this.$emit('selectedKitChange', this.selectedKit)
    this.supplier = ''

    // Send change on material data
    const materialData = this.availableSurgeryOpmeKits && this.availableSurgeryOpmeKits.find(kit => kit.id === this.selectedKit)
    if (materialData) {
      this.$emit('materialDataChange', materialData)
    }
  }

  selectedKitV2Change() {
    this.$emit('selectedKitChange', this.selectedKit)
    this.supplier = ''

    // Send change on material data
    const materialData = this.availableSurgeryOpmeKitsV2 && this.availableSurgeryOpmeKitsV2.find(kit => kit.id === this.selectedKit)
    if (materialData) {
      this.materialV2Change(materialData.kitMaterials)
    }
  }

  surgeryTechniqueChange() {
    this.$emit('surgeryTechniqueChange', this.surgeryTechnique)
  }

  onSurgeryTechniqueChange(event) {
    this.$emit('surgeryTechniqueChange', event)
    this.updateAvaliableOpmeKits()
  }

  updateAvaliableOpmeKits() {
    const { kitsDeOpme: protocolSurgeryOpmeKits, kitsDeOpmeV2 } = this.protocolData

    this.allKitsWithSurgeryTechnique = true

    const filteredKitsBySurgeryTechnique = protocolSurgeryOpmeKits && protocolSurgeryOpmeKits.length > 0
      && protocolSurgeryOpmeKits.filter((opmeKit) => {
        if (!opmeKit.tecnicaDeCirurgia) {
          this.allKitsWithSurgeryTechnique = false
        }

        return !this.surgeryTechnique || (opmeKit.tecnicaDeCirurgia && opmeKit.tecnicaDeCirurgia.id === this.surgeryTechnique)
      })

    this.availableSurgeryOpmeKits = filteredKitsBySurgeryTechnique && filteredKitsBySurgeryTechnique.length > 0
      && filteredKitsBySurgeryTechnique.map(opmeKit => ({
        id: opmeKit.id,
        description: opmeKit.nome,
        kitMaterials: opmeKit.opmes.map(opme => ({
          id: opme.id,
          description: opme.descricao,
          quantity: opme.quantidade,
          anvisaCode: opme.codigoAnvisa,
          supplier: this.getOpmeSupplierLabel(this.protocolSuppliers),
          supplierId: '',
          canDoctorUpdateQuantity: opme.medicoPodeAlterarAQuantidade,
          fornecedores: opme.fornecedores || [], 
        })),
      })) as any

    // Update kits v2
    const filteredKitsV2BySurgeryTechnique = kitsDeOpmeV2 && kitsDeOpmeV2.length > 0
      && kitsDeOpmeV2.filter((opmeKit) => {
        if (!opmeKit.tecnicaDeCirurgia) {
          this.allKitsWithSurgeryTechnique = false
        }

        return !this.surgeryTechnique || (opmeKit.tecnicaDeCirurgia && opmeKit.tecnicaDeCirurgia.id === this.surgeryTechnique)
      })

    this.availableSurgeryOpmeKitsV2 = filteredKitsV2BySurgeryTechnique && filteredKitsV2BySurgeryTechnique.length > 0
      && filteredKitsV2BySurgeryTechnique.map((opmeKit) => {
        const kitMaterials = opmeKit.materiais.map((opme) => {
          // Fill fornecedor if exists just one
          const selectedFornecedor = opme.fornecedores.length === 1 ? opme.fornecedores[0] : undefined

          // Fill selected material if exists just one
          let selectedMaterial: IProtocoloMaterialCodificado | undefined
          if (selectedFornecedor && opme.materiaisCodificados.length === 1) {
            selectedMaterial = opme.materiaisCodificados[0]!
          }

          return {
            description: opme.nomeTecnico,
            quantity: opme.quantidade,
            anvisaCode: '',
            supplier: this.getOpmeSupplierLabelV2(opme.fornecedores),
            supplierId: '',
            canDoctorUpdateQuantity: opme.medicoPodeAlterarAQuantidade,
            material: opme,

            selectedFornecedor,
            selectedMaterial,
          }
        })

        return {
          id: opmeKit.id,
          description: opmeKit.nome,
          kitMaterials,
        }
      }) as any

    if (this.selectedKit && this.availableSurgeryOpmeKitsV2 && this.availableSurgeryOpmeKitsV2.length > 0) {
      const kitData = this.availableSurgeryOpmeKitsV2.find(kit => kit.id === this.selectedKit)
      this.materialV2Change(kitData!.kitMaterials)
    }
  }

  availableSurgeryTechniques: { id: any; description: any; }[] = []
  availableSurgeryOpmeKits: { id: any; description: any; kitMaterials: any; }[] = []
  availableSurgeryOpmeKitsV2: { id: any; description: any; kitMaterials: any; }[] = []
  supplier: string

  protocoloSupplier(material: any) {
    if (material.fornecedores && material.fornecedores.length > 0) {
      return material.fornecedores.map(elem => ({
        id: elem.fornecedorId,
        description: elem.fornecedorNome,
      }))
    }
    return this.protocolSuppliers
  }

  get protocolSuppliers() {
    return this.protocolData && this.protocolData.fornecedores.map(elem => ({
      id: elem.fornecedorId,
      description: elem.fornecedorNome,
    }))
  }

  get backofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get surgerySolicitationStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get fidelizationGlobalStore() {
    return getModule(BackofficeFidelizacaoStore, this.$store)
  }

  get mainSurgerySolicitationStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get mainProcedure() {
    return this.mainSurgerySolicitationStore.solicitacaoCirurgia.procedimento
  }

  get associatedProcedures() {
    return this.mainSurgerySolicitationStore.solicitacaoCirurgia.procedimentosAssociados
  }

  get surgerySolicitationData() {
    if (this.backoffice) {
      return this.backofficeGlobalStore.solicitacao
    }

    return this.surgerySolicitationStore.solicitacao
  }

  get protocolPendencyData() {
    const surgeryProtocolData = this.surgerySolicitationData && this.surgerySolicitationData.protocoloDeCirurgia
    const surgerySolicitationFidelizationData = surgeryProtocolData && surgeryProtocolData.fidelizacao
    const protocolPendencyData = surgerySolicitationFidelizationData && surgerySolicitationFidelizationData.sugestaoDeProtocolo

    return protocolPendencyData
  }

  beforeDestroy() {
    this.protocol = ''
    this.surgeryTechnique = ''
    this.selectedKit = ''
    this.availableSurgeryTechniques = []
    this.availableSurgeryOpmeKits = []
  }

  protocolData: IProtocolo

  async onAvailableProtocolChange(protocolId: string) {
    this.$emit('surgeryProtocolChange', protocolId)

    this.surgeryTechnique = ''
    this.selectedKit = ''

    this.surgeryTechniqueChange()
    this.selectedKitChange()

    const { hospitalId } = this.surgerySolicitationData

    this.protocolData = await this.fidelizationGlobalStore.getSurgerySolicitationProtocol({ hospitalId, protocolId }) as IProtocolo

    // Fill main procedure laterality from the solicitation
    if (this.mainProcedure && this.protocolData.procedimentoPrincipal.codigo === this.mainProcedure.codigo) {
      (this.protocolData.procedimentoPrincipal as any).lateralidade = this.mainProcedure.lateralidade
    }

    // Fill associeted procedures laterality from the solicitation
    if (this.associatedProcedures && this.associatedProcedures.length > 0 && this.protocolData.procedimentosAssociados) {
      this.protocolData.procedimentosAssociados.forEach((protocolProcedure) => {
        const procedureInSolicitation = this.associatedProcedures!
          .find(solicitationProcedure => solicitationProcedure.codigo === protocolProcedure.codigo)

        if (procedureInSolicitation) {
          (protocolProcedure as any).lateralidade = procedureInSolicitation.lateralidade
        }
      })
    }

    const { tecnicasDeCirurgia: protocolSurgeryTechniques } = this.protocolData
    this.availableSurgeryTechniques = protocolSurgeryTechniques && protocolSurgeryTechniques.map(technique => ({
      id: technique.id,
      description: technique.nome,
    }))

    this.updateAvaliableOpmeKits()

    this.$emit('selectedProtocolDataChange', this.protocolData)
  }

  get availableProtocols(): { id: string, description: string }[] {
    return this.fidelizationGlobalStore.surgerySolicitationProtocols.map(protocol => ({
      id: protocol.id,
      description: protocol.nome,
    }))
  }

  get fidelizationProtocolPendencyComment(): string | undefined {
    const surgeryProtocolData = this.surgerySolicitationData && this.surgerySolicitationData.protocoloDeCirurgia
    const surgerySolicitationFidelizationData = surgeryProtocolData && surgeryProtocolData.fidelizacao
    const comment = surgerySolicitationFidelizationData && surgerySolicitationFidelizationData.observacaoDaPendenciaDeProtocolo

    return comment
  }

  get fidelizationJustification(): string | undefined {
    const surgeryProtocolData = this.surgerySolicitationData && this.surgerySolicitationData.protocoloDeCirurgia
    const surgerySolicitationFidelizationData = surgeryProtocolData && surgeryProtocolData.fidelizacao
    const reason = surgerySolicitationFidelizationData && surgerySolicitationFidelizationData.justificativaFidelizacao

    return reason
  }

  get regulacaoJustification(): string | undefined {
    const surgeryProtocolData = this.surgerySolicitationData && this.surgerySolicitationData.protocoloDeCirurgia
    const surgerySolicitationFidelizationData = surgeryProtocolData && surgeryProtocolData.regulacao
    const reason = surgerySolicitationFidelizationData && surgerySolicitationFidelizationData.observacaoParaFidelizacao

    return reason
  }

  get regulacaoAnalisysObservation(): string | undefined {
    const surgeryProtocolData = this.surgerySolicitationData && this.surgerySolicitationData.protocoloDeCirurgia
    const surgerySolicitationFidelizationData = surgeryProtocolData && surgeryProtocolData.regulacao
    const reason = surgerySolicitationFidelizationData && surgerySolicitationFidelizationData.observacaoDaAnalise

    return reason
  }

  get doctorProtocolReasons() {
    const surgerySolicitationData = this.backofficeGlobalStore.solicitacao
    const surgeryProtocolData = surgerySolicitationData && surgerySolicitationData.protocoloDeCirurgia
    const protocolRejectionReasons = surgeryProtocolData && surgeryProtocolData.justificativasMedico

    return protocolRejectionReasons && protocolRejectionReasons.map((elem) => {
      let justificativaOrigemDescricao = ''
      // eslint-disable-next-line default-case
      switch (elem.justificativaOrigem) {
        case ProtocoloJustificativaOrigemEnum.pedidoInicial:
          justificativaOrigemDescricao = 'Solicitação'
          break

        case ProtocoloJustificativaOrigemEnum.fidelizacao:
          justificativaOrigemDescricao = 'Pendência de protocolo'
          break
      }

      return {
        ...elem,
        justificativaOrigemDescricao,
      }
    })
  }

  get doctorProtocolReasonFiles(): { name: string, url: string }[] | undefined {
    const surgerySolicitationData = this.backofficeGlobalStore.solicitacao
    let surgeryProtocolFilesData = surgerySolicitationData.laudos

    surgeryProtocolFilesData = surgeryProtocolFilesData.filter(fileData => fileData.tipoDocumento === 'JustificativaMedicoNaoSegueOProtocolo')

    return surgeryProtocolFilesData.map(file => ({
      name: file.nomeOriginalArquivo,
      url: file.url,
    }))
  }

  get statusFidelizacao() {
    const surgerySolicitationData = this.backofficeGlobalStore.solicitacao
    return surgerySolicitationData && surgerySolicitationData.statusFidelizacao
  }

  get opmeInfo() {
    let opmeData

    if (this.surgerySolicitationData.grupoOpmeDaSolicitacao && this.surgerySolicitationData.grupoOpmeDaSolicitacao.length > 0) {
      opmeData = this.surgerySolicitationData.grupoOpmeDaSolicitacao[0].opmes
    } else if (this.surgerySolicitationData.grupoDeOpme && this.surgerySolicitationData.grupoDeOpme.opmes.length > 0) {
      opmeData = this.surgerySolicitationData.grupoDeOpme.opmes
    } else {
      opmeData = []
    }

    const parsedOpmeData = opmeData.map(opmeItem => ({
      description: opmeItem.opme ? opmeItem.opme.descricao : opmeItem.descricao,
      quantity: opmeItem.quantidade,
      supplier: opmeItem.fornecedor1 ? opmeItem.fornecedor1.nome : opmeItem.fornecedor1Nome,
    }))

    return parsedOpmeData
  }

  get procedureInfo() {
    return {
      code: this.surgerySolicitationData.procedimento!.codigo,
      description: this.surgerySolicitationData.procedimento!.descricao,
      quantity: this.surgerySolicitationData.procedimento!.quantidade,
      laterality: this.surgerySolicitationData.procedimento!.lateralidade,
    }
  }

  get associatedProceduresInfo() {
    return this.surgerySolicitationData.procedimentosAssociados && this.surgerySolicitationData.procedimentosAssociados.map(procedure => ({
      code: procedure!.codigo,
      description: procedure!.descricao,
      quantity: procedure!.quantidade,
      laterality: procedure!.lateralidade,
    }))
  }

  get needSelectSurgeryTechnique() {
    return this.availableSurgeryTechniques && this.availableSurgeryTechniques.length > 0 && !this.surgeryTechnique
      && this.allKitsWithSurgeryTechnique
  }

  getOpmeSupplierLabel(suppliers) {
    if (suppliers && suppliers.length > 0) {
      const firstSupplierName = suppliers[0].description
      const totalSuppliers = suppliers.length

      if (suppliers.length === 1) {
        return firstSupplierName
      }

      const extraSuppliersCount = totalSuppliers - 1
      return `${firstSupplierName} +${extraSuppliersCount} ${extraSuppliersCount === 1 ? 'fornecedor' : 'fornecedores'}`
    }

    return '-'
  }

  getOpmeSupplierLabelV2(data: IProtocoloFornecedor[]) {
    if (data && data.length > 0) {
      const firstSupplierName = data[0].fornecedorNome
      const totalSuppliers = data.length

      if (data.length === 1) {
        return firstSupplierName
      }

      const extraSuppliersCount = totalSuppliers - 1
      return `${firstSupplierName} +${extraSuppliersCount} ${extraSuppliersCount === 1 ? 'fornecedor' : 'fornecedores'}`
    }

    return '-'
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }
}
